<!--
    校区管理-学生管理-学生绑定新手机
    功能：手动和二维码方式学生绑定手机号
    组件: el-tabs
-->
<template>
  <div class="dialog-wap">
    <el-dialog
      :visible.sync="visible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      title="学生绑定新手机"
      width="514px"
    >
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick">
        <el-tab-pane
          label="手动绑定新号"
          name="first">
          <hander-bind
            :student-info="curData"
            @close-dialog="handleClose"
            @refresh-data="handleRefresh"/>
        </el-tab-pane>
        <el-tab-pane
          label="生成学生二维码"
          name="second">
          <student-code
            :student-info="curData"
            @close-dialog="handleClose" />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import HanderBind from './handerBind';
import StudentCode from './studentCode';

export default {
  name: 'BindPhoneDialog',
  components: {
    HanderBind,
    StudentCode,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    curData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeName: 'first',
    };
  },
  methods: {
    handleClose() {
      this.$emit('close-dialog');
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleRefresh() {
      this.$emit('refresh-data');
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-wap {
  .el-dialog__wrapper{
  /deep/ .el-dialog__header{
    border-bottom: 1px solid #E9E9E9;
  }
  /deep/ .el-dialog__body{
    padding-top: 10px;
    }
  }
  /deep/ .el-tabs__item.is-active {
    color: #FF7838;
  }
  /deep/ .el-tabs__active-bar{
    background-color:#FF7838
  }
  /deep/ .el-tabs__header{
    margin-bottom: 34px;
  }
  /deep/ .el-button--primary{
    min-width: auto;
    background: #FF7838!important;
    border-color: #FF7838!important;
  }
  /deep/ .el-form-item{
    margin-bottom: 8px!important;
  }
  /deep/ .el-form-item__label{
    padding-right: 5px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/Student/components/BindPhoneDialog/index.vue